export default __webpack_public_path__ + "static/media/4602.64664ea6.png";